export const adminOrganizationHostEvents = (params: { organizationId: number; hostId: number }) =>
  `organization:${params.organizationId}:${params.hostId}`;
